import React from 'react';
import { motion } from 'framer-motion';
import { Globe } from 'lucide-react';
interface NavbarProps {
  lang: 'en' | 'es';
  onToggleLang: () => void;
  onBook: () => void;
}
export function Navbar({
  lang,
  onToggleLang,
  onBook
}: NavbarProps) {
  return <motion.nav initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    delay: 0.1,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed top-0 left-0 right-0 z-40 bg-brand-dark/80 backdrop-blur-md border-b border-brand-cream/5" data-id="element-238">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between" data-id="element-239">
        {/* Brand */}
        <span className="text-brand-gold tracking-[0.15em] text-xs md:text-sm font-medium uppercase drop-shadow-[0_0_8px_rgba(201,168,76,0.5)]" data-id="element-240">
          ISASHY
        </span>

        {/* Coming Soon */}
        <span className="text-[#39FF14] text-sm md:text-base font-sans font-medium italic tracking-wider animate-pulse drop-shadow-[0_0_10px_rgba(57,255,20,0.6)]" data-id="element-241">
          Coming Soon
        </span>

        <div className="flex items-center gap-3 md:gap-4" data-id="element-242">
          {/* Language Toggle */}
          <button onClick={onToggleLang} className="flex items-center gap-1.5 text-brand-cream/70 hover:text-brand-cream text-xs md:text-sm font-sans transition-colors px-3 py-1.5 border border-brand-cream/10 hover:border-brand-cream/25" data-id="element-243">
            <Globe className="w-3.5 h-3.5 text-brand-gold" data-id="element-244" />
            <span data-id="element-245">{lang === 'en' ? 'Español' : 'English'}</span>
          </button>

          {/* Book CTA */}
          <button onClick={onBook} className="bg-brand-gold hover:bg-brand-gold/90 text-brand-dark text-xs md:text-sm px-4 py-1.5 font-sans font-medium tracking-wide transition-all duration-300" data-id="element-246">
            {lang === 'en' ? 'Book Now' : 'Reservar'}
          </button>
        </div>
      </div>
    </motion.nav>;
}